module.exports = __webpack_public_path__ + "img/icon41.ac7edd39.png";